<template>
  <v-dialog v-model="show" width="500px">
    <v-card class="mt-2">
      <v-card-title>紐付きSJL納入場所追加</v-card-title>
      <v-card-actions>
        <v-btn @click="add">{{$t('app.buttons.add')}}</v-btn>
        <v-btn @click="back">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form>
          <v-container fluid>
            <v-layout column>
              <v-flex>
                <remote-autocomplete label="事業本部" url="divisions/kv?type=BU" v-model="buId"/>
              </v-flex>
              <v-flex>
                <remote-autocomplete
                  label="紐付きSJL納入場所"
                  url="warehouses/sjl-kv"
                  v-model="sjlWarehouseId"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      buId: null,
      sjlWarehouseId: null,
      resolve: null,
      reject: null
    }
  },
  methods: {
    popup() {
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    add() {
      this.show = false
      this.resolve({ buId: this.buId, sjlWarehouseId: this.sjlWarehouseId })
      this.warehouseId = null
      this.buId = null
    },
    back() {
      this.show = false
    }
  }
}
</script>
